import { useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import { Estrellas } from '../reutilizables/estrellas/Estrellas'
import * as calificarVendedorService from '../servicios/calificarVendedorService'
import BordePrincipal from '../ui/BordePrincipal'
import './Estrellas.css'
import Error from '../ui/Error'

const CALIFICACION_MIN_LENGTH = 20

const Calificar = () => {
  const { idPedidoItem, idPublicacion, idVendedor } = useParams()
  const [error, setError] = useState({})
  const location = useLocation().pathname.split('/')[1]
  const esProducto = location === 'CalificarProducto'
  const titulo = esProducto
    ? 'Contanos qué te pareció el producto'
    : '¿Cómo fue la atención del vendedor?'

  const navigate = useNavigate()
  const { loginDataContext: { idUsuario: idUsuarioCalifica } = {} } = useAuth()
  const idPedidoItemParsed = parseInt(idPedidoItem)
  const idPublicacionParsed = parseInt(idPublicacion)
  const idVendedorParsed = parseInt(idVendedor)

  const [formData, setFormData] = useState({
    idPedidoItem: idPedidoItemParsed,
    idUsuarioCalifica: idUsuarioCalifica,
    calificacionAlVendedor: 0,
    calificacionAlItem: 0,
    comentario: '',
    idUsuarioCalificado: idVendedorParsed,
    idItem: idPublicacionParsed
  })

  const onSubmit = async (e) => {
    try {
      e.preventDefault()
      const nuevaCalificacion = {
        idPedidoItem: formData.idPedidoItem,
        idUsuarioCalifica: formData.idUsuarioCalifica,
        calificacionAlVendedor: formData.calificacionAlVendedor,
        calificacionAlItem: formData.calificacionAlItem,
        comentario: formData.comentario,
        idUsuarioCalificado: formData.idUsuarioCalificado,
        idItem: formData.idItem
      }

      const calificacion = esProducto
        ? formData.calificacionAlItem
        : formData.calificacionAlVendedor

      if (calificacion === 0 || formData.comentario === '') {
        setError({
          errores:
            calificacion === 0
              ? 'Por favor, ingresá una puntuación para la calificación.'
              : 'Por favor, escribí una opinión para la calificación.'
        })
        return
      } else if (formData.comentario.length < CALIFICACION_MIN_LENGTH) {
        setError({
          errores: 'Por favor, ingresá al menos 20 caracteres para tu opinión.'
        })
        return
      }

      const { data } = await calificarVendedorService.insertar(nuevaCalificacion)

      if (data?.resultado === false) {
        setError({
          errores: data.mensaje || 'Ya se calificó esta publicación'
        })
        return
      }

      setFormData((prev) => ({
        ...prev,
        idCalificacion: data.idCalificacion
      }))
      navigate('/Pedidos')
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar la calificación.`
      toastErrorLog(error, mensaje, 'calificacionVendedor')
    }
  }

  const handleStarClick = (estrella) => {
    const propiedad = esProducto ? 'calificacionAlItem' : 'calificacionAlVendedor'
    setFormData((prev) => ({
      ...prev,
      [propiedad]: estrella
    }))
    setError((prev) => ({
      ...prev,
      errores: ''
    }))
  }

  const onChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
    setError((prev) => ({
      ...prev,
      errores: ''
    }))
  }

  const volver = () => {
    navigate('/Pedidos')
  }

  return (
    <div>
      <BordePrincipal titulo="Calificar Producto">
        <h4 className="text-center">{titulo}</h4>
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-12 col-lg text-center ml-auto mr-auto mb-4">
            <form onSubmit={onSubmit}>
              <Estrellas
                calificacion={
                  esProducto ? formData.calificacionAlItem : formData.calificacionAlVendedor
                }
                handleStarClick={handleStarClick}
              />
              <div className="contenedor-error-calificacion">
                <Error name="errores" errores={error} mostrarBordeError={false}>
                  <textarea
                    onChange={onChange}
                    className="text-area w-100"
                    name="comentario"
                    id="comentario"
                    rows="10"
                  ></textarea>
                </Error>
              </div>
              <div className="row mt-4 flex-column flex-md-row">
                <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-center mb-3 mb-md-0">
                  <button className="btn btn-primary w-100 " onClick={volver} type="button">
                    Volver
                  </button>
                </div>
                <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-center mb-3 mb-md-0">
                  <button type="submit" className="btn btn-info w-100 ">
                    Enviá tu Opinión
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </BordePrincipal>
    </div>
  )
}

export default Calificar
